// let arr = ["gmail.com", "yahoo.com", "hotmail.com", "aol.com" , "hotmail.co.uk", "hotmail.fr" , "msn.com", "yahoo.fr",	"wanadoo.fr", "orange.fr", "comcast.net", "yahoo.co.uk"];

export function checkStringContains(arr, string) {
    for (let domain of arr) {
        if (string.includes(domain)) {
            return false;
        }
    }
    return true;
}

// export const baseURL = 'http://localhost:5002/api'
export const baseURL = 'https://api.agilustech.in/api'
// export const baseURL = 'http://13.203.148.191:5002/api'
// export const baseURL = 'http://192.168.80.207:5002/api'
